import { LINKEDJSON } from "./constants/specialContentTypes";

const getCompaniesList = ({ page, ...restData }) => ({
  method: "GET",
  url: "/companies",
  data: { ...restData, page: page + 1 },
});

const addCompany = (data) => ({
  method: "POST",
  url: "/companies",
  data,
  headers: { ...LINKEDJSON },
});

const updateCompany = ({ id, ...data }) => ({
  method: "PUT",
  url: `/companies/${id}`,
  data,
  headers: { ...LINKEDJSON },
});

const deleteCompany = ({ id }) => ({
  method: "DELETE",
  url: `/companies/${id}`,
});

export const companiesApi = {
  getCompaniesList,
  addCompany,
  updateCompany,
  deleteCompany,
};
